import { httpsCallable } from "firebase/functions";
import { functions } from "./firebase";

export async function startCheckout(priceId, tier) {
  const call = httpsCallable(functions, "createCheckoutSession");
  const { data } = await call({
    priceId,
    tier,
    successUrl: `${window.location.origin}${window.location.pathname}?checkout=success`,
    cancelUrl: `${window.location.origin}${window.location.pathname}?checkout=cancel`,
  });
  window.location.href = data.url;
}

export async function startFeaturedListingCheckout(listingId, priceId) {
  const call = httpsCallable(functions, "createFeaturedListingCheckout");
  const { data } = await call({
    listingId,
    priceId,
    successUrl: `${window.location.origin}${window.location.pathname}?checkout=success`,
    cancelUrl: `${window.location.origin}${window.location.pathname}?checkout=cancel`,
  });
  window.location.href = data.url;
}

export async function openBillingPortal() {
  const call = httpsCallable(functions, "createPortalSession");
  const { data } = await call({
    returnUrl: `${window.location.origin}${window.location.pathname}`,
  });
  window.location.href = data.url;
}
